import { render, staticRenderFns } from "./CarouselSelection.vue?vue&type=template&id=6bcb35ce&scoped=true&"
import script from "./CarouselSelection.vue?vue&type=script&lang=js&"
export * from "./CarouselSelection.vue?vue&type=script&lang=js&"
import style0 from "./CarouselSelection.vue?vue&type=style&index=0&id=6bcb35ce&lang=scss&scoped=true&"
import style1 from "./CarouselSelection.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcb35ce",
  null
  
)

export default component.exports